import React, { Component } from "react";
import "antd/dist/antd.css";
import { Route, Switch, withRouter } from "react-router-dom";
import UserAccess from "./Containers/carrier/UserAccess";
import Login from "./Containers/Login";
import ForgotPassword from "./Containers/ForgotPassword";
import ConfirmForgotPassword from "./Containers/ConfirmForgotPassword";
import "./Stylesheet/carrier.scss";
import Application from "./Containers/Application";
import { withAppContext } from "./store/contextStore";
import DriverLogin from "./Containers/driver/DriverLogin";
import driverSignup from "./Containers/customer/driverSignup";
import customerSignup from "./Containers/customer/customerSignup";

class App extends Component {
  async componentDidMount() {
    let user = JSON.parse(localStorage.getItem("userDetails"));
    // const user = await userLogedinOrNot();
    // const { user } = this.props.context.state;
    if (user) {
      console.log("User Logged in");
    } else {
      console.log("User Not Logged in");
      if (
        this.props.location.pathname !== "/login" &&
        this.props.location.pathname !== "/" &&
        this.props.location.pathname !== "/forgotPassword" &&
        this.props.location.pathname !== "/confirm_forgot_password" &&
        this.props.location.pathname !== "/app/customersignup" &&
        this.props.location.pathname !== "/carrier_login/Signup"
      ) {
        window.location = "/";
      }
    }
  }
  render() {
    return (
      <Switch>
        <Route path="/app" component={Application} />
        <Route path="/carrier_app" component={Application}></Route>
        <Route path="/customer" component={Application}></Route>
        <Route path="/carrier_login" component={UserAccess}></Route>
        <Route path="/forgotPassword" component={ForgotPassword}></Route>
        <Route
          path="/confirm_forgot_password"
          component={ConfirmForgotPassword}
        ></Route>
        <Route path="/driverSignUp" component={driverSignup}></Route>
        <Route path="/customersignup" component={customerSignup}></Route>
        <Route path="/" component={Login}></Route>
      </Switch>
    );
  }
}
export default withAppContext(withRouter(App));
